export default "__VITE_ASSET__BHQ2LVnn__"